import React from 'react';
import { useParams, Link } from 'react-router-dom';
import './offerCard.css';
import {
  shopIcon, 
  locationIcon, 
  usersIcon, 
  scheduleIcon, 
  timerIcon, 
  contractIcon, 
  starIcon
} 
from '../../../../utils/icons';

const OfferCard = ({ offer }) => {

  // Handle location display with proper fallback
  const getLocationDisplay = () => {
    if (offer.location && offer.location.address) {
      return offer.location.address;
    } else if (offer.location && typeof offer.location === 'string') {
      return offer.location;
    } else if (offer.region || offer.comuna) {
      const locationParts = [];
      if (offer.region) locationParts.push(offer.region);
      if (offer.comuna && offer.comuna !== "No hay") locationParts.push(offer.comuna);
      return locationParts.length > 0 ? locationParts.join(', ') : 'No especificado';
    }
    return 'No especificado';
  };

  return (
    <div className="offer-card__container">
      <div className="offer-card__col-1">
        <div className="offer-card__title-container">
          <h2>{offer.position}</h2>
        </div>
        <div className="offer-card__icon-info-container">
          {locationIcon}
          <div className="offer-card__info-container">
            <p><strong>Ubicación:</strong></p>
            <p>{getLocationDisplay()}</p>
          </div>
        </div>
      </div>

      <div className="offer-card__col-2">
        <div className='offer-card__detail'>
          <div className="offer-card__icon-info-container">
            {timerIcon}
            <div className="offer-card__info-container">
              <p><strong>Horario:</strong></p>
              <p>{offer.schedule}</p>
            </div>
          </div>
          <div className="offer-card__icon-info-container">
            {contractIcon}
            <div className="offer-card__info-container">
              <p><strong>Contrato:</strong></p>
              <p>{offer.contract}</p>
            </div>
          </div>
          <div className="offer-card__icon-info-container">
            {usersIcon}
            <div className="offer-card__info-container">
              <p><strong>Vacantes:</strong></p>
              <p>{offer.vacancies}</p>
            </div>
          </div>
          <div className="offer-card__icon-info-container">
            {starIcon}
            <div  className="offer-card__info-container">
              <p><strong>Experiencia:</strong></p>
              <p>{offer.yearsOfExperience}</p>
            </div>
          </div>
        </div>
        <div className='offer-card__description'>
          <div className="offer-card__description-container">
            <p id="offer-card__description">{offer.description}</p>
          </div>
          <div className="offer-card__date-container">
            <p className="published-date">
              <strong>
                Publicado el {new Date(offer.createdAt).toISOString().split('T')[0]}
              </strong>
            </p>
          </div>
        </div>
      </div>  

      <div className="offer-card__buttons ">
        <Link to={`/trabajos/${offer.id}/aplicar`}>
            <button className="offer-card__button">Postular</button>
        </Link>
        <Link to={`/trabajos/${offer.id}`}>
            <button className="offer-card__button">Detalle</button>
        </Link>
      </div>
      
    </div>
  );
};

export default OfferCard;
